import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MobDirective } from './directives/phone-mask.directive';
import { NumberDirective } from './directives/numbers-only.directive';
import { InputRefDirective } from './directives/input-ref.directive';
import { KhegmUiComponentsModule } from 'khegm-ui-components';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaFormsModule, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { NgCircleProgressModule } from 'ng-circle-progress';

const RECAPTCHA_CHALLENGE_KEY = environment.Recaptcha.ChallengePublicKey;
const RECAPTCHA_HIDDEN_KEY = environment.Recaptcha.PublicKey;

@NgModule({
  declarations: [
    InputRefDirective,
    MobDirective,
    NumberDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    KhegmUiComponentsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module,
    NgCircleProgressModule.forRoot({})
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: RECAPTCHA_HIDDEN_KEY },
    { provide: RECAPTCHA_SETTINGS, useValue: { siteKey: RECAPTCHA_CHALLENGE_KEY } as RecaptchaSettings }
  ],
  exports: [ CommonModule, RouterModule,
    InputRefDirective,
    MobDirective,
    NumberDirective,
    KhegmUiComponentsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module,
  ]
})
export class CoreModule { }
